export enum TopicStageEnum {
  InPreparation = 0,
  Open = 1,
  Suggested = 2,
  Rejected = 3,
  Closed = 4,
  Deleted = 5,
  Completed = 6
}
